import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

/** `top`: message sits under the header (less empty space). `centered`: vertically centered in the pane. */
export type TEmptyStateLayout = 'top' | 'centered';

@Component({
  selector: 'app-empty-state',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon],
  template: `
    <div class="empty-state-host" [class.empty-state-host--top]="layout() === 'top'">
      <div class="empty-state">
        <div class="empty-state__icon-wrap">
          <mat-icon>{{ icon() }}</mat-icon>
        </div>
        <h2 class="empty-state__title">{{ title() }}</h2>
        @if (subtitle()) {
          <p class="empty-state__subtitle">{{ subtitle() }}</p>
        }
        <ng-content />
      </div>
    </div>
  `,
  styleUrl: './empty-state.component.scss',
})
export class EmptyStateComponent {
  icon = input('chat_bubble_outline');
  title = input('Nothing selected');
  subtitle = input('');
  layout = input<TEmptyStateLayout>('top');
}
